export default __webpack_public_path__ + "static/media/VisitorTypes.24277c33.jpg";